"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
function getLocalize() {
    if (typeof Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return Localize;
}
;
/* istanbul ignore next */
function getLocalizeFormat() {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
}
/* istanbul ignore next */
exports.LocaleData = { get: function () { return getLocalizeFormat().localeData; } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    validProject: function (a) { return t('@tableau__nested-project-explorer/validProject', a); },
    insufficientPermissionToMoveTo: function (a) { return t('@tableau__nested-project-explorer/insufficientPermissionToMoveTo', a); },
    invalidContentDestination: function (a) { return t('@tableau__nested-project-explorer/invalidContentDestination', a); },
    moveToProject_siteRootDestination: function (a) { return t('@tableau__nested-project-explorer/moveToProject_siteRootDestination', a); },
};
//# sourceMappingURL=Localize.js.map